export default __webpack_public_path__ + "static/media/buenalumno.538233b3.jpg";